document.addEventListener('click', (e) => {
    let target = e.target;

    if (target.classList.contains('accordion-title')) {
        const selected_accordion = target.closest('.accordion-wrapper');
        const accordion_parent = target.closest('.accordion-category');

        if (selected_accordion.classList.contains('active')) {
            setTimeout(() => {
                selected_accordion.classList.remove('active');
            }, 100);
        } else if (accordion_parent) {
            const sibling_accordions = accordion_parent.querySelectorAll('.accordion-wrapper');
            // Close sibling accordions
            if (sibling_accordions) {
                sibling_accordions.forEach(accordion => {
                    accordion.classList.remove('active');
                });

                setTimeout(() => {
                    selected_accordion.classList.add('active');
                }, 100);
            }
        }
    }
});
